import React from 'react'
import { connect } from 'react-redux'
import Card, { TitleCard } from '../../core/Card'
import Line from '../../core/Line'
import { ForwardIcon, Icon, PlusIcon, ReportIcon, CarIcon, CoinIcon, RefundIcon } from '../../core/icons'
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch
} from 'react-router-dom'
import { Slider, Select, Button, Col, Row, Icon as AIcon } from 'antd';
import DataExport from './DataExport'
import moment from 'moment'
import EmptyState from '../../core/components/EmptyState'
import { Tooltip } from 'antd';
import './DataExports.css'
import twix from 'twix'

const getDateRangeFromFilename = (str)=> str.match(/(\d{4}(\-\d{2}){2})/gi)


const Export = ({onClick, file_name, public_url, expires, entity, file_type, start_year, start_month, isGenerating, last_modified}) =>
  <Line onClick={() =>!isGenerating && window.open(public_url)} className={isGenerating ? 'pending' : ''}>
    <Col span={2}>
      {/transaction/.test(file_name) ? <ReportIcon/> : null}
      {/trip/.test(file_name) ? <CarIcon/>: null}
      {/revenue/.test(file_name) ? <RefundIcon/>: null}
      {/expenses/.test(file_name) ? <CoinIcon/>: null}
    </Col>
    <Col span={13}>

      {/team-summary/.test(file_name) &&"Team Summary "}

      {/transaction/.test(file_name) &&"Transactions & Receipts"}
      {/trip/.test(file_name) &&"Trips"}
      {/revenue/.test(file_name) &&"Revenue"}
      {/expense/.test(file_name) &&"Expenses"}

      <br/>
      <small>
        {
          `${
            moment(getDateRangeFromFilename(file_name)[0])
            .twix(
              getDateRangeFromFilename(file_name)[1]
            ).format({
              hideTime: true,
              monthFormat: 'MMM',
              dayFormat: 'Do'
            })
          }`
        }
      </small>

      <br/>
      <small style={{
        color: isGenerating?'inherit':'rgb(36, 150, 197)',
        textDecoration: isGenerating?'inherit':'underline',
        // padding: '5px'
      }}>

        {file_name}
      </small>
      <br/>
      <small style={{color:'lightgrey'}}>
        {isGenerating? 'Requested ': 'Created '}
        {moment(last_modified).fromNow()}
      </small>
    </Col>
    <Col span={5}>
      {isGenerating ? 'Generating...' : expires+' days'}
      {/* {isGenerating ? 'Generating...' : (expires>0) ? expires+' days': 'expired'} */}
    </Col>
    <Col span={4}>
      <Row justify="center" type="flex">
        {isGenerating ? <AIcon type="loading" /> : <AIcon style={{fontSize: "22px"}} type="download" />}
      </Row>
    </Col>
  </Line>


const All = ({dataExports, onClick, pristine, disabled, loading, save, match, isFetchingInitialPoll}) =>
  <div className="DataExports">
    <TitleCard>
      <h1>Data Exports</h1>
      <Link to={`${match.path}/new`}>
        <Button type="primary" icon="plus" >
          New Export
        </Button>
      </Link>
    </TitleCard>

    <Card>

      {/* { dataExports.map((props, i)=> <Export key={i} onClick={onClick} {...props}/>)} */}
      {dataExports.length<1 ?
        <EmptyState
          title="No Data Exports yet."
          buttonLink="/teams/data-exports/new"
          buttonText="New Export"
          buttonIcon='plus'
          icon={ReportIcon}
          isFetching={isFetchingInitialPoll}
        />
      : <div>
        <Line className="header">
            <Col xs={12} md={14}>
              NAME
            </Col>
            <Col xs={10} md={6}>
              <Tooltip
                title={`Don't worry, only the download link wll expire after 7 days. You can create a data export at anytime.`}
              >
                EXPIRES IN
                <AIcon style={{marginLeft: "10px", color: "#444444"}} type="question-circle-o" />
              </Tooltip>
            </Col>
            <Col xs={2} md={4}>
              <Row justify="center" type="flex">
                DOWNLOAD
              </Row>
            </Col>
        </Line>
        {

          dataExports
          .sort((a,b)=>moment(b.last_modified).diff(moment(a.last_modified)))
          .map((props, i)=> <Export key={i} onClick={onClick} {...props}/>)
        }
      </div>
      }
    </Card>
  </div>

export default All



// WEBPACK FOOTER //
// ./src/enterprise/data-export/All.js